<template>
	<div id="page">

		<!-- 页头 -->
		<pagehead />

		<!-- 上 -->
		<el-container class="sdTop w1k2 mauto mt40 pt15 bw br5">
			<el-main>
				<!-- 表单 -->
				<el-form class="df fww" ref="form" :model="form" label-width="100px">

					<!-- 名称 -->
					<el-form-item class="f1" label="名称">
						<el-input v-model="form.entname" placeholder="输入名称"></el-input>
					</el-form-item>

					<!-- YCODE -->
					<el-form-item class="f1" label="YCODE">
						<el-input v-model="form.ycode" onkeydown="value = value.replace(/[^0-9]/g,'')"
							placeholder="输入YCODE"></el-input>
					</el-form-item>

					<!-- 省市区 -->
					<el-form-item class="options f1" label="省市区">
						<template>
							<!-- 省 -->
							<el-select v-model="form.proCode" placeholder="请选择" @change="getCity" clearable filterable>
								<el-option v-for="(item,index) in province" :key="index" :label="item.proName"
									v-model="item.proCode"></el-option>
							</el-select>
							<!-- 市 -->
							<el-select v-model="form.cityCode" placeholder="请先选择省份" @change="getRegion" clearable
								filterable :disabled="!form.proCode">
								<el-option v-for="(item,index) in city" :key="index" :label="item.cityName"
									v-model="item.cityCode"></el-option>
							</el-select>
							<!-- 区 -->
							<el-select v-model="form.districtCode" placeholder="请先选择城市" clearable filterable
								:disabled="!form.cityCode">
								<el-option v-for="(item,index) in district" :key="index" :label="item.districtName"
									v-model="item.districtCode"></el-option>
							</el-select>
						</template>
					</el-form-item>

					<!-- 状态 -->
					<el-form-item class="f1" label="状态">
						<el-checkbox-group v-model="recordStatus">
							<el-checkbox :label="item.code" v-for="(item,index) in typeName" :key="index">{{item.name}}
							</el-checkbox>
						</el-checkbox-group>
					</el-form-item>

					<!-- 机构一级类型 -->
					<el-form-item class="options f1" label="机构一级类型" v-if="more">
						<template>
							<el-select v-model="form.category" placeholder="请选择" @change="getOrgan2" clearable
								filterable>
								<el-option v-for="(item,index) in organ1" :key="index" :label="item.name"
									v-model="item.code"></el-option>
							</el-select>
						</template>
					</el-form-item>

					<!-- 机构二级类型 -->
					<el-form-item class="options f1" label="机构二级类型" v-if="more">
						<template>
							<el-select v-model="form.categoryDetailed" placeholder="请先选择机构一级类型" clearable filterable
								:disabled="!form.category">
								<el-option v-for="(item,index) in organ2" :key="index" :label="item.name"
									v-model="item.code"></el-option>
							</el-select>
						</template>
					</el-form-item>

					<!-- 社会组织信用码 -->
					<el-form-item class="f1" label="社会组织信用码" v-if="more">
						<el-input v-model="form.creditCode" placeholder="输入社会组织信用码"></el-input>
					</el-form-item>

					<!-- 医疗机构字段 -->
					<el-form-item class="seacher w100p c333 f14" v-if="more">医疗机构字段</el-form-item>

					<!-- 医院等级 -->
					<el-form-item class="options f1" label="医院等级" v-if="more">
						<template>
							<el-select v-model="form.hospitalGrade" placeholder="请选择" clearable filterable>
								<el-option v-for="(item,index) in hgardy" :key="index" :label="item.name"
									v-model="item.code"></el-option>
							</el-select>
						</template>
					</el-form-item>

					<!-- 医院级别 -->
					<el-form-item class="options f1" label="医院级别" v-if="more">
						<template>
							<el-select v-model="form.hospitalLevel" placeholder="请选择" clearable filterable>
								<el-option v-for="(item,index) in hlevel" :key="index" :label="item.name"
									:value="item.code"></el-option>
							</el-select>
						</template>
					</el-form-item>

					<!-- 经营性质 -->
					<el-form-item class="options f1" label="经营性质" v-if="more">
						<el-checkbox-group v-model="economicType">
							<el-checkbox :label="item.code" v-for="(item,index) in nature" :key="index">{{item.name}}
							</el-checkbox>
						</el-checkbox-group>
					</el-form-item>

					<!-- 搜索按钮 -->
					<el-form-item class="seacher df dfc aic w100p">
						<el-button type="danger" @click="clearMore">清空</el-button>
						<el-button type="primary" @click="todetails">搜索</el-button>
					</el-form-item>

					<!-- 操作按钮 -->
					<div class="drop w100p df dfc aic">
						<div class="dropBtn cp" @click="more = !more">
							<!-- 下拉展示更多 -->
							<img v-if="!more" src="../assets/drop.png">
							<!-- 点击显示简略信息 -->
							<img v-if="more" src="../assets/up.png">
						</div>
					</div>
				</el-form>
			</el-main>
		</el-container>

		<!-- 中间内容 -->
		<el-container class="details w1k2 mauto mt30 mb35 pt15 bw br5">
			<el-header class="df dfsb aic w100p">
				<div class="detailsTL">
					<!-- <el-button type="success" @click="selAll">全选</el-button> -->
					<el-button type="warning" @click="derive">导出</el-button>
				</div>
				<div class="detailsTR c666 f14">共{{count}}条数据，当前展示{{listlength}}条数据</div>
			</el-header>
			<el-main class="seacherTable mt25">

				<el-table ref="multipleTable" :data="tableData[ page > 0 ? ( page - 1 ) : 0 ]" stripe border>

					<el-table-column type="index" v-if="fieldList.length" width="50"></el-table-column>

					<el-table-column label="操作" v-if="fieldList.length" width="50">
						<template slot-scope="scope">
							<el-button @click="lookTable(scope.row)" type="text" size="small">查看</el-button>
						</template>
					</el-table-column>

					<el-table-column v-for="(item,index) in fieldList" :key="index" :prop="item.key" :label="item.value"
						:width="(item.key == 'entname' || item.key == 'addr') ? '200' : ''"></el-table-column>

				</el-table>

				<el-pagination class="selpage mt30 mauto tac" layout="prev, pager, next" :total="total" prev-text="上一页"
					next-text="下一页" @current-change="changePage"></el-pagination>

			</el-main>
		</el-container>

		<!-- 页脚 -->
		<pagefoot />

	</div>
</template>
<script>
	// 全局变量
	var that;
	export default {
		// 页面变量
		data() {
			return {
				//	展示字段
				fieldList: [],
				// 表单头部
				form: {},
				// 状态
				recordStatus: [],
				// 状态名称
				typeName: [],
				// 经营性质名称
				economicType: [],
				// 省
				province: [],
				// 市
				city: [],
				// 区
				district: [],
				// 机构类型1
				organ1: [],
				// 机构类型2
				organ2: [],
				// 经营性质
				nature: [],
				// 医院等级
				hgardy: [],
				// 医院级别
				hlevel: [],
				//对el-checkbox控制不完整的全选状态
				isIndeterminate: false,
				//对el-checkbox控制全选状态
				checkAll: false,
				// 表格数据
				tableData: [],
				// 选中表内容的容器
				multipleSelection: [],
				// 是否下拉
				more: false,
				// 总数量
				count: 0,
				// 返回列表的长度
				listlength: 0,
				// 页码最高数量 单位10
				total: 0,
				// 当前页码
				page: 1,

				isFirstEnter: false

			}
		},

		beforeRouteEnter(to, from, next) {
			if (from.name == 'nextName') { // 这个name是下一级页面的路由name
				to.meta.isBack = true; // 设置为true说明你是返回到这个页面，而不是通过跳转从其他页面进入到这个页面
			}
			next()
		},



		// 实例化后
		created() {

			that = this;

			that.isFirstEnter = true;

		},


		activated() {

			that.util.checkToken((res) => {

				if (!that.$route.meta.isBack || that.isFirstEnter) {

					that.getDataFn() // 这里发起数据请求，(之前是放在created或者mounted中，现在只需要放在这里就好了，不需要再在created或者mounted中请求！！)

				}

				//	请求完后进行初始化
				that.$route.meta.isBack = false

				//	请求完后进行初始化
				that.isFirstEnter = false;
			})

		},


		// 方法集
		methods: {

			// 清空表单
			clearMore() {
				// 清空表单
				that.form = {};
				// 清空多选
				that.recordStatus = that.economicType = [];

			},

			// 查看表格
			lookTable(row) {

				// 跳转公司详情 传递ycode参数
				that.$router.push({
					path: './details',
					query: {
						ycode: row.ycode
					}
				})
			},


			// 进入页面触发的事件
			getDataFn() {

				// 获取省
				that.getPro();


				// 判断有无传参
				if (that.$route.query.value) {

					// 响应式赋值
					that.$set(that.form, 'entname', that.$route.query.value);

					// 赋值搜索值
					// that.form.entname = that.$route.query.value;

					// 新建变量缓存当前路由
					var path = this.$route.path;
					// 赋值路由清空参数
					this.$router.push(path);

					// 执行搜索
					that.todetails();
				}

			},

			// 获取经营性质
			getDictByType() {
				// 请求接口
				that.request({
					url: '/api/business/selectBusDictByType',
					// 上传数据
					data: {
						// 参数 经营性质
						type: 'EconomicType',
					},
					method: 'get',
					// 调用成功
					success(rs) {
						// 返回成功
						if (rs.code == 200) {

							// 赋值经营性质
							that.nature = rs.data;

						} else {
							//弹窗提示用户
							that.$message.error(rs.msg);
						}
					}
				});
			},

			// 切换页码
			changePage(e) {

				// 赋值页码
				that.page = e;

			},

			// 搜索
			todetails() {

				// 判断有无多选
				if (that.recordStatus) {
					// 用','分隔字符串
					that.form.recordStatus = that.recordStatus.join(',');
				}

				// 判断有无多选
				if (that.economicType) {
					// 用','分隔字符串
					that.form.economicType = that.economicType.join(',');
				}

				// 请求接口
				that.request({
					url: '/api/Organization/selectOrganizationList',
					data: that.form,

					load: true,
					// 成功
					success(rs) {
						// 成功
						if (rs.code == 200) {
							// 新建变量存放展示字段
							var field = rs.data.field;

							// 判断是是否有字段
							if (field) {

								// 分割字符串
								field = field.split(",");

								// 新建空数组
								var fieldList = [];

								// 遍历字段的数组
								for (var i = 0; i < field.length; i++) {
									// 新建数组转换字符串
									var arr = field[i].split(":");
									// 添加
									fieldList.push({
										key: arr[0],
										value: arr[1],
									})
								}

								// 赋值
								that.fieldList = fieldList;

							}

							// 赋值总数
							that.count = rs.data.count;
							// 赋值返回列表长度
							that.listlength = rs.data.list.length;

							// 每页显示条数
							that.tableData = that.chunk(rs.data.list, 20);


							that.total = that.tableData.length * 10;

							// 清空查询数据
							// that.form = {};

						} else {
							// 弹窗提示用户
							that.$message.error(rs.msg);
						};
					}
				});
			},

			// 分割字符串
			chunk(arr, size) {
				var rsArr = [];
				for (var i = 0; i < arr.length; i += size) {
					var tempArr = [];
					for (var j = 0; j < size && i + j < arr.length; j++) {
						tempArr.push(arr[i + j]);
					}
					rsArr.push(tempArr);
				}
				return rsArr;
			},

			// 全选
			// selAll() {
			// 赋值表
			// that.tableData[that.page - 1].forEach(row => {
			// that.$refs.multipleTable.toggleRowSelection(row);
			// })
			// },

			// 获取机构一级类型
			getOrgan1() {
				// 请求接口
				that.request({
					url: '/api/business/selectBusDictByType',
					// 传送方式
					method: "get",
					// 上传数据
					data: {
						// 类型 一级机构
						type: 'Category',
					},
					// 调用成功
					success(rs) {
						// 返回成功
						if (rs.code == 200) {
							// 一级机构
							that.organ1 = rs.data;

							// 获取医院等级
							that.getHGardy();
							// 获取医院级别
							that.getHLevel();
							// 获取状态
							that.getType();
							// 获取经营性质
							that.getDictByType();

						} else {
							//弹窗提示用户
							that.$message.error(rs.msg);
						}
					}
				})
			},

			// 获取机构二级类型
			getOrgan2(e) {

				// 删除机构二级类型
				delete that.form.categoryDetailed;
				delete that.form.categoryDetailedName;

				// 请求接口
				that.request({
					url: '/api/business/selectChildCategory',
					// get传参
					method: 'get',
					// 上传数据
					data: {
						// 编码
						fcode: e,
					},
					// 调用成功
					success(rs) {
						// 返回成功
						if (rs.code == 200) {

							// 赋值二级机构
							that.organ2 = rs.data;

						} else {
							//弹窗提示用户
							that.$message.error(rs.msg);
						}
					}
				})
			},

			// 获取医院等级
			getHGardy() {
				// 请求接口
				that.request({
					url: '/api/business/selectBusDictByType',
					// 传送方式
					method: "get",
					// 上传数据
					data: {
						// 类型 医院等级
						type: 'HospitalGrade',
					},
					// 调用成功
					success(rs) {
						// 返回成功
						if (rs.code == 200) {
							// 医院等级
							that.hgardy = rs.data;
						} else {
							//弹窗提示用户
							that.$message.error(rs.msg);
						}
					}
				})
			},

			// 获取医院级别
			getHLevel() {
				// 请求接口
				that.request({
					url: '/api/business/selectBusDictByType',
					// 传送方式
					method: "get",
					// 上传数据
					data: {
						// 类型 医院级别
						type: 'HospitalLevel',
					},
					// 调用成功
					success(rs) {
						// 返回成功
						if (rs.code == 200) {
							// 医院级别
							that.hlevel = rs.data;
						} else {
							//弹窗提示用户
							that.$message.error(rs.msg);
						}
					}
				})
			},

			// 获取省
			getPro() {
				that.request({
					url: "/api/region/getList",
					// 传送方式
					method: "get",
					data: {
						// 省
						regionType: 'pro',
					},
					// 调用成功
					success(rs) {
						if (rs.code == 200) {
							// 赋值省
							that.province = rs.data;

							// 获取机构一级类型
							that.getOrgan1();
						}

					}
				});
			},

			// 获取城市
			getCity(proCode) {
				// 清空市
				delete that.form.cityValue;
				delete that.form.cityCode;
				// that.city = [];
				// 清空区
				delete that.form.districtValue;
				delete that.form.districtCode;

				// 请求接口
				that.request({
					url: "/api/region/getList",
					// 传送方式
					method: "get",
					data: {
						// 城市
						regionType: "city",
						// 省code
						proCode: proCode,
					},
					success(rs) {
						// 赋值市
						that.city = rs.data;

						// 添加数组
						// that.city.unshift({
						// 	cityName: '请先选择省份',
						// 	cityCode: '',
						// })
					}
				})
			},

			// 获取区域
			getRegion(cityCode) {
				// 清空区
				delete that.form.districtValue;
				delete that.form.districtCode;

				// 请求接口
				that.request({
					url: "/api/region/getList",
					// 传送方式
					method: "get",
					data: {
						// 区
						regionType: "district",
						// 城市code
						cityCode: cityCode,
					},
					success(rs) {
						// 清空区
						that.district = rs.data;
					}
				})
			},

			// 获取状态
			getType() {
				// 请求接口
				that.request({
					url: '/api/business/selectBusDictByType',
					// 传送方式
					method: "get",
					// 上传数据
					data: {
						// 类型 状态
						type: 'HCORecordStatus',
					},
					// 调用成功
					success(rs) {
						// 判断返回成功
						if (rs.code == 200) {

							// 赋值状态
							that.typeName = rs.data;

						} else {
							// 弹窗提示用户
							that.$message.error(rs.msg);
						}
					}
				})
			},

			// 点击导出
			derive() {

				// 判断是否有列表可以导出
				if (that.tableData.length == 0) {

					// 判断状态是否有值
					if (!that.recordStatus && !that.economicType) {
						// 弹窗提示
						that.$message.warning('请输入字段查询列表后导出')
						return;
					};
				};

				// 新建变量拼接参数
				var url = that.util.config.host + '/api/Organization/selectExport';
				var data = that.form;
				data.token = localStorage.getItem("token");

				//	新开页面（ 网址 接口 用户token ）
				// window.open(that.util.setUrl(url, data));
        window.location.href=that.util.setUrl(url, data)

			},

		},
	};
</script>
<style>
	/* 头部 */
	.sdTop {
		box-shadow: 0px 6px 18px 3px rgba(193, 193, 193, 0.13);
	}

	/* 头部输入框 */
	.sdTop .el-input__inner {
		/* width: 450px; */
	}

	/* 行 */
	.el-form-item {
		margin-bottom: 20px;
	}

	/* 文字块 */
	.sdTop .el-form-item__label {
		margin-right: 0px;
	}

	/* 右边表单盒子 */
	.sdTop .el-form-item__content {
		width: 400px;
		margin-left: 110px !important;
		color: #111;
	}

	/* 头部输入框左侧文字 */
	.sdTop .el-form-item__label {
		white-space: nowrap;
		text-align: left;
		color: #666;
		font-size: 14px;
		/* text-align-last: justify; */
	}

	/* 头部省市地 */
	.sdTop .options .el-input__inner {
		/* width: 150px; */
		margin-right: 10px;
		padding: 0;
		border: 0;
	}

	/* 头部活动性质 */
	.sdTop .el-checkbox {
		margin: 0 5px 0 0;
	}

	/* 省市区下拉 */
	.sdTop .el-input__suffix {
		right: 20px;
	}

	/* 搜索按钮盒子 */
	.seacher .el-form-item__content {
		width: auto;
		margin: 0 !important;
	}

	/* 搜索按钮 */
	.seacher .el-form-item__content .el-button.el-button--primary {
		width: 110px;
		background-color: #0066dd;
	}

	/* 搜索按钮 */
	.seacher .el-form-item__content .el-button.el-button--danger {
		width: 110px;
	}

	/* 下拉按钮 */
	.dropBtn {
		width: 31px;
		height: 14px;
		transition: .5s;
	}

	/* 鼠标经过下拉按钮 */
	.dropBtn:hover {
		transform: translateY(3px);
	}

	/* 表格头部 */
	.details thead.has-gutter {
		background-color: #E9F3FF !important;
	}

	/* 隔行颜色 */
	.details .el-table__row.el-table__row--striped {
		background-color: #E9F3FF !important;
	}

	/* 去掉自带的默认颜色 */
	.details .el-table th,
	.el-table tr,
	.details .el-table--striped .el-table__body tr.el-table__row--striped td {
		background: none;
	}

	/* 每一个单元格 */
	.details .el-table td,
	.details .el-table th {
		text-align: center !important;
		font-size: 14px;
	}

	/* 选择页码 */
	/* 上一页 ， 下一页 ， 页码块 */
	.selpage .btn-prev,
	.selpage .btn-next,
	.selpage ul li.number {
		margin: 0 1px;
		color: #0060DD;
		border: 1px solid #ddd;
		border-radius: 5px;
	}

	/* 选中的页码块 */
	.selpage ul li.number.active {
		color: white;
		background-color: #0060DD;
		border-color: #0060DD;
	}

	/* 搜索列表 */
	.seacherTable {}

	/* 搜索结果的表格 控制全选的按钮 */
	.seacherTable .has-gutter span.el-checkbox__input {
		display: none;
	}

	/* 经营性质单选 */
	.el-radio-group .el-radio {
		margin: 5px 10px 5px 0;
	}

	/* 禁用输入框 */
	.el-input.is-disabled .el-input__inner {
		background: none;
	}
</style>
